export default __webpack_public_path__ + "static/media/home.9ceaf503.svg";